import React from 'react'
import img1 from '../../assets/png/q1.png'

function Quote() {
  return (

<img src={img1} width="100%"></img>

  )
}

export default Quote